/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：760
 */

var r = require(/* 400 */"../1648/400")
module.exports = function (e, t, n) {
  for (var o in t) r(e, o, t[o], n)
  return e
}
